import { InfoFieldProps } from '../interface/interface';

const InfoField = ({
  label,
  value,
  className
}: InfoFieldProps) => {
  let createMarkup;
  if (typeof value === 'string') {
    createMarkup = () => {
      return { __html: value };
    };
  } else {
    createMarkup = () => {
      return { __html: '' };
    };
  }
  return (
    <div className="basis-full md:basis-6/12 xl:basis-1/3 mb-6">
      <label
        data-testid="infoField-label"
        className="text-base md:text-xl text-secondary-pink-700 font-semibold mb-2"
      >
        {label}
      </label>
      {typeof value === 'string' ? (
        <p
          data-testid="infoField-p"
          className={`font-regular text-primary-blue-500 break-normal ${className}`}
          dangerouslySetInnerHTML={createMarkup() ?? ''}
        />
      ) : (
        <p
          data-testid="infoField-p"
          className={`font-regular text-primary-blue-500 break-normal ${className}`}
        >
          {value}
        </p>
      )}
    </div>
  );
};
export default InfoField;
